import React, { Component } from 'react';

import AddProject from "./AddProject";
import {AuthContext} from "../../authContext";
import AppContent from '../shared/AppContent';
import Button from "../shared/Button";
import PageHeading from '../shared/PageHeading';
import Loading from "../shared/Loading";
import ProjectTable from "./ProjectTable";

import plusIcon from "../../assets/images/icons/add2.svg";
import { getProjects } from "../data/dataCIMToolkit";

class Projects extends Component {
  state = {
    isLoading: true,
    isShowAddProjectForm: false,
    projects: []
  };
  static contextType = AuthContext;
  componentDidMount = async () => {
    await this.loadProjects();
    await this.setState({ isLoading: false });
  };
  loadProjects = async () => {
    await this.setState({isLoading: true});
    if (this.context.userDetails.token !== "") {
      const projects = await getProjects(this.context.token);
      projects.data.sort((a,b) => { return a.name.localeCompare(b.name) })
      await this.setState({projects: projects.data});
    }
    await this.setState({isLoading: false});
  };
  toggleAddProjectForm = () => {
    this.setState({
      isShowAddProjectForm: !this.state.isShowAddProjectForm
    });
  };
  render() {
    return (
      <AppContent>
        <PageHeading>
          <div>My projects</div>
        </PageHeading>
        {
          !this.state.isShowAddProjectForm
          &&
          <div style={{marginBottom:"10px"}}>
            <Button small style={{marginTop:"10px", display:"flex", alignItems:"center"}} onClick={this.toggleAddProjectForm}>
              <img src={plusIcon} alt={`AddNewCityCADModel`} style={{width:"24px", marginRight:"10px"}} />
              <div style={{marginRight:"5px"}}>New project</div>
            </Button>
          </div>
        }
        {this.state.isShowAddProjectForm && <AddProject closeForm={this.toggleAddProjectForm} loadProjects={this.loadProjects} />}
        {this.state.isLoading ? <Loading /> : this.state.isShowAddProjectForm ? "" : <ProjectTable data={this.state.projects} />}
      </AppContent>
    );
  }
}

export default Projects;
